import { useEffect, useRef } from 'react';

/** Accessible first-party confirmation, replacing the browser's native alert. */
export default function BillingConfirmDialog({ onCancel, onConfirm, busy = false }) {
  const cancelRef = useRef(null);
  const confirmRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    const previous = document.activeElement;
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    cancelRef.current?.focus();
    const keyDown = (event) => {
      if (event.key === 'Escape' && !busy) {
        event.preventDefault();
        onCancel();
      }
      if (event.key !== 'Tab') return;
      const candidates = [cancelRef.current, confirmRef.current].filter(
        (item) => item && !item.disabled
      );
      const first = candidates[0];
      const last = candidates[candidates.length - 1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!dialogRef.current?.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener('keydown', keyDown);
    return () => {
      document.body.style.overflow = oldOverflow;
      window.removeEventListener('keydown', keyDown);
      if (previous?.isConnected) previous.focus();
    };
  }, [onCancel, busy]);

  return (
    <div className="cb-billing-modal-layer">
      <div className="cb-billing-modal-shade" aria-hidden="true" />
      <section ref={dialogRef} role="alertdialog" aria-modal="true"
        aria-labelledby="cb-billing-confirm-title"
        aria-describedby="cb-billing-confirm-description"
        className="cb-billing-modal">
        <div className="cb-billing-modal-icon" aria-hidden="true">!</div>
        <h2 id="cb-billing-confirm-title">Simuler la fin de votre abonnement ?</h2>
        <p id="cb-billing-confirm-description">
          Cette opération de test mettra immédiatement fin à vos abonnements
          fictifs actifs. Les contenus Premium redeviendront verrouillés si
          vous n’avez pas d’autre droit valide.
        </p>
        <p className="cb-billing-modal-note">
          Aucun remboursement, débit ou paiement réel n’est effectué.
          Vos abonnements attribués par un administrateur ne sont pas modifiés.
        </p>
        <div className="cb-billing-modal-actions">
          <button ref={cancelRef} type="button" onClick={onCancel} disabled={busy}
            className="cb-billing-btn cb-billing-btn--subtle">Conserver mon abonnement</button>
          <button ref={confirmRef} type="button" onClick={onConfirm} disabled={busy}
            className="cb-billing-btn cb-billing-btn--danger">
            {busy ? 'Traitement en cours…' : 'Confirmer l’expiration'}
          </button>
        </div>
      </section>
    </div>
  );
}
